
import { Card, CardContent } from '@shazambanking/sdk/components';
import { showSuccessNotification } from '@shazambanking/sdk/services/notifications';
// iziToast.css - safe to prune in webpack tree shaking
import 'izitoast/dist/css/iziToast.css';
import * as React from 'react';
import Header from './Header';
import { NewAccountFormWrapper } from './NewAccountFormWrapper';
import { HtmlL10n } from '../../common/HtmlL10n';
import { l10n as naoL10n } from '../l10n/newAccount';
import { mapL10nKeys } from '../../common/util/l10n';


export default function NewAccountConfirmation() {
  showSuccessNotification('New Account Request Success');
  // njansen 5/13/22 - jankety solution to make l10n work without app bootstrap, this needs called on every page requiring l10n
  const l10n = mapL10nKeys(naoL10n);

  return (
    <NewAccountFormWrapper>
      <Header />
      <Card noGutters className="new-account-panel">
        <CardContent>
          <HtmlL10n l10n={l10n.confirmation} className="new-account-desc" />
        </CardContent>
      </Card>
    </NewAccountFormWrapper>
  );
};
